import { LocalStorage } from 'quasar';

export function flush(state) {
  state.accessToken = '';
  state.pushToken = '';
  state.externalId = null;
  state.phone = '';
  state.name = '';
  state.email = '';
  state.address = '';
  state.extra = '';
  state.postalCode = '';
  state.creditAmount = '';
  state.coupon = null;
  state.addresses = [];
  state.paymentMethods = [];
  state.items = [];
  state.isInternal = false;
}

export function updateUser(state, payload) {
  state.accessToken = payload.accessToken;
  state.pushToken = payload.androidPushToken;
  state.externalId = payload.externalId;
  state.phone = payload.phone;
  state.name = payload.name;
  state.email = payload.email;
  state.address = payload.address;
  state.extra = payload.extra;
  state.creditAmount = payload.creditAmount;
  state.coupon = payload.coupon;
  state.postalCode = payload.postalCode;
  // state.paymentMethods = payload.paymentMethods;
  state.addresses = payload.addresses;
  // Don't override currently set state. Only update if supplied. Only set when authenticating.
  state.isInternal = payload.isInternal ? payload.isInternal : state.isInternal;

  // For development purposes only
  if (process.env.NODE_ENV === 'development') {
    state.isInternal = true;
  }
}

export function updateAllOrders(state, payload) {
  state.orders = payload;
}

export function updateUserExtra(state, payload) {
  state.extra = payload;
}

export function updateLoggedIn(state, payload) {
  state.isLoggedIn = payload;
}

export function storeUserInLocalStorage(state) {
  LocalStorage.set('user', state);
}

export function removeUserFromLocalStorage() {
  LocalStorage.remove('user');
}

export function updateUserSettings(state, payload) {
  state.name = payload.name;
  state.extra = payload.extra;
  state.address = payload.address;
  state.postalCode = payload.postalCode;
}

export function setUserPaymentMethod(state, payload) {
  state.paymentMethods = payload;
}

export function setUserItems(state, payload) {
  state.items = payload;
}

export function updateUserPushToken(state, { token }) {
  state.pushToken = token;
}
